import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const GlenroyCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Glenroy" suburbSlug="glenroy" variant="cdbs-dentist" />
);

export default GlenroyCdbsDentistPage;
